import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
// @ts-expect-error no types yet
import { bender } from 'legacy-hubspot-bender-context'; // import-eslint-disable-line
import { stringify } from 'hub-http/helpers/params';
import { deployed, isLocal } from './env';
const PAGE_PREVIEW_PATH = '_hcms/preview/content';
const TEMPLATE_PREVIEW_PATH = '_hcms/preview/template/multi';
const getBaseUrl = () => '/theme-editor';
export const getRootUrl = () => `${getBaseUrl()}/${PortalIdParser.get()}`;
export const getBranchPreviewBuild = () => {
  if (bender.staticDomain.includes('dynamic.hsappstatic.net')) {
    return bender.staticDomain.split(/b-|\./g)[1];
  }
  return null;
};
const getPreviewPath = (queryParams, previewPageId) => {
  const previewPath = previewPageId ? `${PAGE_PREVIEW_PATH}/${previewPageId}` : TEMPLATE_PREVIEW_PATH;
  return `${previewPath}?${stringify(queryParams)}`;
};
export const buildPreviewUrl = (previewDomain, themePath, previewPageId, previewTemplatePath, extraParams = {}) => {
  const hasPageIdOrTemplatePath = previewPageId || previewTemplatePath;
  if (!themePath || !hasPageIdOrTemplatePath || !previewDomain) {
    return null;
  }
  const queryParams = Object.assign({
    buffer_theme: true,
    path: previewTemplatePath,
    from_buffer: previewPageId ? false : undefined,
    portalId: PortalIdParser.get(),
    preview_theme: true,
    theme_path: themePath,
    themePreviewerUI: true,
    hsEditorApp: 'theme'
  }, extraParams);
  if (isLocal() || !deployed()) {
    queryParams.localAssets = true;
    queryParams.appDomain = document.location.origin;
  }

  // Pass along branch preview build ID if it exists
  const branchPreviewBuild = getBranchPreviewBuild();
  if (branchPreviewBuild) {
    queryParams.branchPreviewBuild = branchPreviewBuild;
  }
  let previewPath = getPreviewPath(queryParams, previewPageId);
  if (enviro.getShort('preview') === 'local') {
    previewPath = `cos-rendering/v1/public/${previewPath}`;
  }
  return `//${previewDomain}/${previewPath}`;
};
export const updateAssetUrlTimestamp = url => {
  const timestampRegex = /([?&]t=)[^&]+/;
  if (!url.match(timestampRegex)) {
    return `${url}&t=${Date.now()}`;
  }
  return url.replace(timestampRegex, `$1${Date.now()}`);
};
export const getThemeSettingsUrl = () => {
  return `/settings/${PortalIdParser.get()}/website/themes`;
};